import { readBuffer } from './utilsFile';
import { checkByByte } from './utils';

export function webpFormat(urlObj, quality) {
  return new Promise((resolve) => {
    if (window.SUPPORT_WEBP) {
      urlObj = formatWebpParams(urlObj, quality);
      resolve(urlObj);
    } else {
      var img = new Image();
      img.onload = function () {
        var result = img.width > 0 && img.height > 0;
        if (result) {
          window.SUPPORT_WEBP = true;
          urlObj = formatWebpParams(urlObj, quality);
        }
        resolve(urlObj);
      };
      img.onerror = function () {
        window.SUPPORT_WEBP = false;
        resolve(urlObj);
      };
      img.src =
        "data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA";
    }
  });
}
// 格式化webp参数
export function formatWebpParams(urlObj, quality = 75) {
  let cdnReg = /^(https|http):\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com/;
  if (window.SUPPORT_WEBP) {
    if (typeof urlObj === "object") {
      Object.keys(urlObj).forEach((key) => {
        if (cdnReg.test(urlObj[key])) {
          let url = urlObj[key].split("?")[0];
          urlObj[key] = `${url}?imageMogr2/format/webp/quality/${quality}`;
        }
      });
    } else if (urlObj) {
      if (cdnReg.test(urlObj)) {
        let url = urlObj.split("?")[0];
        urlObj = `${url}?imageMogr2/format/webp/quality/${quality}`;
      }
    }
  }
  return urlObj;
}

export async function isUploadImageLegal(file) {
  const buffers = await readBuffer(file, 0, 8);
  const uint8Array = new Uint8Array(buffers);
  const pngHex = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];
  const jpgHex = [0xff, 0xd8, 0xff, 0xe0];
  const jpegHex = [0xff, 0xd8, 0xff, 0xe1];
  const gifHex = [0x47, 0x49, 0x46, 0x38];

  const isGif = checkByByte(gifHex)(uint8Array, {
    offset: 0,
    length: gifHex.length,
  });
  if (isGif) return false;

  const isPng = checkByByte(pngHex)(uint8Array, {
    offset: 0,
    length: pngHex.length,
  });
  // 检查是否有 APNG 动画
  const CHUNK_HEADER_LENGTH = 8; // 每个块的头部长度（长度+类型+CRC）
  const HEADER_LENGTH = 8; // PNG文件头部长度
  const checkAPNG = async () => {
    let position = HEADER_LENGTH;
    while (position < file.size) {
      // 读取块的长度和类型
      const chunkHeaderBuffer = await readBuffer(
        file,
        position,
        position + CHUNK_HEADER_LENGTH
      );
      const chunkHeaderArray = new Uint8Array(chunkHeaderBuffer);
      const chunkLength =
        (chunkHeaderArray[0] << 24) |
        (chunkHeaderArray[1] << 16) |
        (chunkHeaderArray[2] << 8) |
        chunkHeaderArray[3];
      const chunkType = chunkHeaderArray.subarray(4, 8);
      position += CHUNK_HEADER_LENGTH;
      // 检查 `acTL` 块
      if (
        Array.from(chunkType).every(
          (val, index) => val === "acTL".charCodeAt(index)
        )
      ) {
        return true; // 发现 `acTL` 块，可能是APNG
      }
      // 跳过块数据和CRC校验码
      position += chunkLength + 4; // 块数据长度 + CRC长度
    }
    return false;
  };
  const isAPNG = isPng ? await checkAPNG() : false;
  if (isPng) return !isAPNG;

  const isJpg = checkByByte(jpgHex)(uint8Array, {
    offset: 0,
    length: jpgHex.length,
  });
  if (isJpg) return true;

  const isJpeg = checkByByte(jpegHex)(uint8Array, {
    offset: 0,
    length: jpegHex.length,
  });
  if (isJpeg) return true;

  return false;
}

export function formatWebplImg(url, q = 40) {
  if (!url) return;
  let isSvg = /\.svg$/.test(url);
  if (isSvg) return url;

  let cdnReg = /^(https|http):\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com/;
  if (cdnReg.test(url)) {
    if (window.SUPPORT_WEBP) {
      let u = url.split("?")[0];
      url = `${u}?imageMogr2/format/webp/quality/${q}/ignore-error/1`;
    } else {
      let u = url.split("?")[0];
      url = `${u}?imageMogr2/quality/${q}/ignore-error/1`;
    }
  }
  return url;
}
export function formatThumbnailImg(url, thumbnail) {
  if (!url) return;
  let isSvg = /\.svg$/.test(url);
  if (isSvg) return url;

  let cdnReg = /^(https|http):\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com/;
  if (cdnReg.test(url)) {
    if (url.includes("?")) {
      let reg = /\/thumbnail\/.*?\//;
      if (reg.test(url)) {
        url = url.replace(reg, `/thumbnail/${thumbnail}/`);
      } else {
        url += `/thumbnail/${thumbnail}/`;
      }
    } else {
      url += `?imageMogr2/thumbnail/${thumbnail}/`;
    }
  }
  return url;
}
export function formatGifFrame(url, format = "png") {
  let cdnReg = /^(https|http):\/\/[a-zA-Z0-9]+\.(max-c|maxjia)\.com/;
  if (cdnReg.test(url)) {
    if (url.includes("?")) {
      let reg = /\/format\/.*?\//;
      if (reg.test(url)) {
        url = url.replace(reg, `/format/${format}/`);
      } else {
        url += `/format/${format}/`;
      }
    } else {
      url += `?imageMogr2/format/${format}/`;
    }
  }
  return url;
}
export function formatMeMeUrl(url, type) {
  if (!url) return;
  url = formatWebplImg(url, 400);
  if (type === "emoji") {
    url = formatThumbnailImg(url, "52x");
  } else if (type === "sticker") {
    url = formatThumbnailImg(url, "140x");
  }
  return url;
}

export async function getImgWidthHeight(url) {
  return new Promise((resolve) => {
    let img = new Image();
    img.onload = function () {
      resolve({
        width: img.width,
        height: img.height,
      });
    };
    img.src = url;
  });
}

export function uint8arraytoImage(data, type = "png") {
  var blob = new Blob([data]);
  return new File([blob], "index." + type, { type: "image/" + type });
}

/**
 * 获取图片的宽高
 * @param {File} file 图片文件
 * @returns {Promise<{file: File, width: number, height: number}>} 图片的宽高
 */
export async function getImageDimension(file) {
  return new Promise((resolve, reject) => {
    let url = window.URL || window.webkitURL || window.mozURL || window.msURL;
    const img = new Image();
    let imgUrl = url.createObjectURL(file);

    img.onload = function () {
      url.revokeObjectURL(imgUrl); // 释放内存
      resolve({
        file,
        width: this.naturalWidth,
        height: this.naturalHeight,
      });
    };

    img.onerror = function () {
      URL.revokeObjectURL(url);
      reject(new Error('无法加载图片'));
    };

    img.src = imgUrl;
  });
}

/**
 * 获取图片的宽高
 * @param {Array<File>} files 图片文件
 * @returns {Promise<Array<{file: File, width: number|null, height: number|null}>>} 图片的宽高
 */
export async function getImageWidthHeight(files) {
  if (!Array.isArray(files)) {
    return [
      {
        file: files,
        width: null,
        height: null,
      },
    ];
  }

  const res = await Promise.all(files.map((file) => getImageDimension(file)));

  return res;
}
